export const emailHistoryFrag = `
    id
    createdAt
    recipientAddress
`;
